import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Form } from 'semantic-ui-react';

import cm from 'helpers/commons';
import * as cmAPI_Action from 'actions/commons';

class SikdaePolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
  }

  componentWillMount() {
    this.sikdaePolicySearch(null, { value: 0 });
  }

  shouldComponentUpdate(nextProps, nextState) {
    let result = false;
    //식대 정책 데이터가 변경 되었을 때
    let policyChange = JSON.stringify(nextProps.sikdaePolicy) !== JSON.stringify(this.props.sikdaePolicy);
    //식대 정책 idx가 변경 됬을을 때
    let valueChange = JSON.stringify(nextState.value) !== JSON.stringify(this.state.value);
    //dim 변경
    let isDimChange = JSON.stringify(nextProps.isDim) !== JSON.stringify(this.props.isDim);

    if (policyChange || valueChange || isDimChange) {
      // 식대 정책 데이터가 변경 되었을 때는 value를 0으로 초기화 해준다.
      if (policyChange) {
        this.setState({
          value: 0
        });
      }
      result = true;
    }
    return result;
  }

  sikdaePolicySearch = async (e, data) => {
    let value = data.value === 0 || !data.value ? null : data.value;

    const { commonFn } = this.props;
    await commonFn.changePolicy({
      type: 'policy',
      name: 'value',
      value: value
    });

    this.setState({
      value: value
    });
  };

  render() {
    const { sikdaePolicy, sikdaeGroupVal, style, longterm, isDim, isLongTerm } = this.props;
    const { value } = this.state;
    const defaultOptions = [{ value: 0, text: '식대정책 전체' }];
    let policy = null;

    if (sikdaePolicy) {
      if (isLongTerm) {
        policy = cm.selectDataForMat(sikdaePolicy.data.policy, '식대정책 전체', 'longterm');
      } else {
        policy = cm.selectDataForMat(sikdaePolicy.data.policy, '식대정책 전체', '');
      }
    }

    return (
      <Form.Field inline className="com-sikdae-policy">
        {/* <label>식대정책</label> */}
        {policy && sikdaeGroupVal ? (
          <Dropdown
            placeholder="식대정책 전체"
            selection
            disabled={isDim}
            value={value ? value : 0}
            options={policy}
            onChange={this.sikdaePolicySearch}
          />
        ) : (
          <Dropdown placeholder="식대정책 전체" selection disabled defaultValue={0} options={defaultOptions} />
        )}
      </Form.Field>
    );
  }
}
SikdaePolicy = connect(
  (state) => ({
    policyIdx: state.commons.policy
  }),

  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changePolicy: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(SikdaePolicy);

export default SikdaePolicy;
